import { Heading } from '@spark-web/heading';
import { ApplicationSubmissionStatus } from '../../pages/ApplicationStatus/types';
import { useGetPageTitle } from './hooks';

type PageTitleProps = {
  readonly status?: ApplicationSubmissionStatus;
};

function PageTitle({ status }: PageTitleProps) {
  const pageTitle = useGetPageTitle(status);
  return (
    <Heading level="1" align="center">
      {pageTitle}
    </Heading>
  );
}

export default PageTitle;
